import React from 'react'
import SearchPicker from '../common/SearchPicker'

const ColorPicker = (props) => {

    const { state } = props

    const option = (color) => <span>{`${color.code}, ${color.name}, ${color.hexCode}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}, ${state.hexCode}` : ""}
            option={(color) => option(color)}
        />
    )
}

export default ColorPicker